import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import MemberEmailForm from './MemberEmailForm';

const DISMISS_KEY = 'mishtameretEmailPromptDismissed';

function isDismissed() {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

/** הזמנה להוסיף כתובת מייל, בדף המבחנים ולמי שאין לו כתובת. אחרי השמירה או הדחייה נעלמת */
const EmailPromptNotice = ({ theme, member, onMemberChange }) => {
  const [hidden, setHidden] = useState(isDismissed);

  if (hidden || member.email) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // בלי אחסון — נעלם רק עד הטעינה הבאה
    }
    setHidden(true);
  };

  return (
    <Box
      sx={{
        bgcolor: theme.surface,
        borderRadius: 2.5,
        border: `1px solid ${theme.borderSoft}`,
        px: 2,
        py: 1.5,
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography sx={{ fontWeight: 700, color: theme.text }}>
          רוצים לקבל את הציון גם במייל?
        </Typography>
        <Button
          onClick={dismiss}
          sx={{ color: theme.textMuted, fontFamily: theme.fontBody, flexShrink: 0, minHeight: 36 }}
        >
          לא עכשיו
        </Button>
      </Box>
      <MemberEmailForm theme={theme} member={member} onSaved={onMemberChange} />
    </Box>
  );
};

export default EmailPromptNotice;
